const profile = {
  title: "मेरी प्रोफाइल",
  premiumBtn: "प्रीमियम बनें",
  orderInfoTitle: "खाता अनुमति जानकारी",
  tableProduct: "उत्पाद",
  tableStatus: "स्थिति",
  tablePermissionDate: "अनुमति तिथि",
  tableValidPeriod: "वैध अवधि",
  validStauts: "वैध",
  expiredStauts: "समय-सीमा समाप्त",
  noData: "कोई डेटा उपलब्ध नहीं है",
};

export default profile;
